<template>
  <div class="uk-overflow-auto">
    <Modal v-model:isOpen="isLoadDetailsOpen" modalId="pod-load-details-modal" maxWidth="6xl" @close="closeLoadDetails">
      <template #content>
        <LoadDetailModal v-if="selectedLoad" :load="selectedLoad"></LoadDetailModal>
      </template>
    </Modal>
    <!-- @refreshOrders="updateOrders" -->
    <table
      class="uk-text-small uk-text-small uk-table-middle uk-table uk-table-small uk-table-divide uk-table-small uk-table-striped uk-table-justify uk-table-middle uk-table-hover"
    >
      <thead>
        <tr>
          <th class="uk-table-shrink">#</th>
          <th class="uk-table-shrink uk-text-center">Load</th>
          <th class="uk-text-center">Status</th>
          <th class="uk-text-center">Driver</th>
          <th class="uk-text-center">Customer</th>
          <th class="uk-text-center">Document</th>
          <!-- <th class="uk&#45;text&#45;center"></th> -->
          <!-- <th class="uk-table-shrink">Type</th> -->
          <!-- <th class="uk-preserve-width" v-if="!condensed" uk-width>Customer</th> -->
          <th class="uk-table-middle uk-text-center">Created</th>
          <th class="uk-table-middle uk-text-center">Last Updated</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(load) in loads" :key="load.id" v-on:click="selectLoad(load.id)">
          <td>{{ load.id }}</td>
          <td>
            <b>{{ load.loadDocumentId }}</b>
          </td>

          <td>{{load.status}}</td>
          <td>{{load.driver.fullName || '---'}}</td>
          <td>{{(load.customer && load.customer.name) || '---'}}</td>

          <!--  File uploader or show file -->
          <td v-if="uploadLoading">
            <span uk-spinner uk-tooltip="Uploading POD" />
          </td>
          <td v-else-if="load.podFileUrl !== null" v-on:click.stop>
            <a
              uk-icon="icon: file-pdf"
              uk-tooltip="View POD"
              :href="load.podFileUrl"
              target="_blank"
            ></a>
          </td>
          <td v-else v-on:click.stop>
            <label class="file-select">
              <!-- We can't use a normal button element here, as it would become the target of the label. -->
              <div>
                <a uk-icon="icon: upload" uk-tooltip="Upload POD manually"></a>
              </div>
              <!-- Now, the file input that we hide. -->
              <input type="file" @change="event => uploadPOD(load.driver.id, load.id, event)" />
            </label>
          </td>

          <td>{{formatDatetime(load.createdAt)}}</td>
          <td>{{load.lastUpdatedAt && formatDatetime(load.lastUpdatedAt) || '---'}}</td>

          <template v-if="tableType === 'active'">
            <td v-on:click.stop>
              <a uk-icon="icon: check" uk-tooltip="Archive Load" v-on:click="archiveLoad(load.id)"></a>
            </td>
          </template>
          <template v-else-if="tableType === 'archived'">
            <td v-on:click.stop>
              <a
                uk-icon="icon: refresh"
                uk-tooltip="Un-archive Load"
                v-on:click="unarchiveLoad(load.id)"
              ></a>
            </td>
          </template>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import Modal from '@/components/core/Modal/Modal.vue';

import moment from 'moment';

import LoadDetailModal from './LoadDetailModal.vue';

import ARCHIVE_LOAD from '../../gql/pod_tracking/ArchiveLoad.gql';
import UNARCHIVE_LOAD from '../../gql/pod_tracking/UnarchiveLoad.gql';

export default defineComponent({
  name: 'LoadsTable',
  components: {
    LoadDetailModal,
    Modal,
  },
  props: ['loads', 'user', 'tableType', 'condensed'],

  data() {
    return {
      selectedLoadId: null as number | null,
      loading: [],
      uploadLoading: false,
    };
  },
  // errorCaptured(err, vm, info) {
  //   this.error = `${err.stack}\n\nfound in ${info} of component`;
  //   console.log('--************* errorCaptured:', this.error);
  //   return false;
  // },
  computed: {
    selectedLoad(): any {
      const vm = this as any;
      if (!vm.selectedLoadId) return null;
      return (vm.loads || []).find((l: any) => l.id === vm.selectedLoadId) || null;
    },
    isLoadDetailsOpen: {
      get(): boolean {
        return (this as any).selectedLoadId !== null;
      },
      set(value: boolean) {
        if (!value) {
          (this as any).closeLoadDetails();
        }
      },
    },
  },
  methods: {
    // loadAvailable(load) {
    //   if (container.yardStatus.includes('Available')) {
    //     return true;
    //   }
    //   return false;
    // },
    selectLoad(loadIdx: number) {
      (this as any).selectedLoadId = loadIdx;
    },
    closeLoadDetails() {
      (this as any).selectedLoadId = null;
    },
    // refreshLoadStatus(containerIndex: any) {
    //   const container: any = this.filteredContainers[containerIndex];
    //   // const idx = this.filteredIdxs[containerIndex];
    //   // const container = this.filteredContainers[containerIndex];
    //   this.loading.push(containerIndex);
    //   console.log('requesting container update', container);
    //   this.$apollo
    //     .mutate({
    //       mutation: UpdateContainer,
    //       variables: {
    //         containerId: container.containerId,
    //       },
    //     })
    //     .then((data) => {
    //       if (this.loading.includes(containerIndex)) {
    //         this.loading = this.loading.filter((idx) => idx !== containerIndex);
    //       }
    //       this.$emit('refreshContainers');
    //       // this.$apollo.queries.user.refetch();
    //       console.log(data);
    //     });
    // },
    archiveLoad(loadId: number) {
      const vm = (this as any);

      console.log('emitted archive ', loadId);
      vm.$apollo
        .mutate({
          mutation: ARCHIVE_LOAD,
          variables: {
            loadId,
          },
        })
        .then(() => {
          vm.$emit('archiveLoad', loadId);
        });
    },
    unarchiveLoad(loadId: number) {
      const vm = (this as any);

      vm.$apollo
        .mutate({
          mutation: UNARCHIVE_LOAD,
          variables: {
            loadId,
          },
        })
        .then(() => {
          vm.$emit('unarchiveLoad', loadId);
        });
    },
    uploadPOD(driverId: number, loadId: number, event) {
      const vm = (this as any);
      // Send to backend to upload to S3
      const file = event.target.files[0];
      console.log('file0: ', file.name);

      const formData = new FormData();
      formData.append('driverId', driverId.toString());
      formData.append('loadId', loadId.toString());
      formData.append('file', file);

      vm.uploadLoading = true;

      fetch('/api/upload-pod', {
        method: 'POST',
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          console.log('uploaded file!!!', data);
          vm.$emit('refreshLoads');
          vm.uploadLoading = false;
        })
        .catch((error) => {
          // TODO: show the error to user
          console.error('Upload file err: ', error);
          vm.uploadLoading = false;
        });
    },
    formatDatetime(datetimeStr: string) {
      return moment.utc(datetimeStr).local().format('MM/DD/YY @ hh:mm a');
    },
  },
});
</script>

<style scoped>
.file-select > .select-button {
  padding: 1rem;

  color: white;
  background-color: #2ea169;

  border-radius: 0.3rem;

  text-align: center;
  font-weight: bold;
}

/* Don't forget to hide the original file input! */
.file-select > input[type='file'] {
  display: none;
}
</style>
